import { Flex, View } from '@adobe/react-spectrum';
import moment from 'moment';
import { statusColor, truncateText } from '../../../../utils/helperUtil';
import styles from './card_component.module.css';
import { ChevronRight } from 'react-bootstrap-icons';
import { Badge } from 'react-bootstrap';
import { useMemo } from 'react';
import { useCategoryColors } from '../../../../hooks/useCategoryColors';

interface ICardComponentProps {
  item: any;
  activityStatusList: any;
}

const CardComponent: React.FC<ICardComponentProps> = ({ item, activityStatusList }) => {
  const { getProductCategoryColor, getTextColor } = useCategoryColors();


  return (
    <Flex direction="column" position={'absolute'} width={'100%'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.card_list}>
      <Flex direction={'row'} position={'relative'} width={'100%'} alignItems={'center'} justifyContent={'start'} UNSAFE_className={styles.card_child_wrapper}>
        <View
          position={'absolute'}
          margin={'0px'}
          height={'calc(100% - 36px)'}
          width={'4px'}
          top={'18px'}
          bottom={'18px'}
          left={'-1px'}
          maxHeight={'100%'}
          zIndex={1}
          UNSAFE_style={{ backgroundColor: (item.statusName === 'Aktivní' || item.statusName === 'aktivní' || item.statusName === 'active' || item.statusName === 'Active') ? '#1976D2' : '#B0BEC5', borderRadius: '3px' }}
        />
        <Flex direction={'column'} width={'100%'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'10px'} zIndex={1}>
          <Flex direction={'column'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'12px'}>
            <Flex direction={'row'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'start'} gap={'8px'}>
              <View flex={1} position={'relative'} UNSAFE_className={styles.heading_text}>
                {item.name}
              </View>
              <View position={'relative'} UNSAFE_className={styles.heading_date}>
                {`${item.amount} ${item.currencyName ? item.currencyName : ''} `}
              </View>
            </Flex>
            <Flex direction={'row'} alignItems={'center'} justifyContent={'start'} gap={'6px'} UNSAFE_className={styles.header_path_wrapper}>
              <View position={'relative'} UNSAFE_className={styles.header_path_text}>
                <span title={`${item.manufacturerName}`}>
                  {item.manufacturerName && truncateText(item.manufacturerName, 25)}
                </span>
              </View>
            </Flex>
          </Flex>
          <View position={'relative'} alignSelf={'stretch'} height={'1px'} UNSAFE_className={styles.header_divider}></View>
          {(item.componentCategoryName || item?.refId || item.typeName) &&
            <Flex direction={'row'} alignItems={'center'} justifyContent={'center'}>
              <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                {item?.typeName && (
                  <Badge
                    style={{ display: "div", alignItems: "center", }}
                    className={styles.greyBadge}
                  >
                    <span >{item.typeName}</span>
                  </Badge>
                )}
                {item?.refId && (
                  <Badge
                    style={{ display: "div", alignItems: "center", }}
                    className={styles.greyBadge}
                  >
                    <span >{item.refId}</span>
                  </Badge>
                )}
                {item?.componentCategoryName && (
                  <Badge
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: getProductCategoryColor(item.componentCategoryName),
                      color: getTextColor(getProductCategoryColor(item.componentCategoryName)),
                    }}
                    bg=""
                    className={styles.purpleBadge}
                  >
                    <span>{item.componentCategoryName}</span>
                  </Badge>

                )}
              </Flex>
            </Flex>
          }
        </Flex>
      </Flex>
      <View UNSAFE_style={{ height: '10px' }} />
    </Flex>
  );
};

export default CardComponent;
